import { useI18n } from '../i18n';
import { GetItButton } from '../components/GetItButton';
import { PhoneMenu } from '../components/PhoneMenu';
import { PRODUCT } from '../lib/constants';
import styles from './Hero.module.css';

export function Hero() {
  const { t } = useI18n();

  return (
    <section className={styles.hero}>
      <div className={styles.copy}>
        {/* Caveat, so the line reads as a muttered aside rather than a claim. */}
        <p className={`hand ${styles.eyebrow}`}>{t.hero.eyebrow}</p>

        <h1 className={styles.headline}>
          {t.hero.headlineA}
          <br />
          {t.hero.headlineB}
        </h1>

        <p className={styles.body}>{t.hero.body}</p>

        <div className={styles.ctaRow}>
          <GetItButton source="hero" variant="primary" size="lg">
            {t.hero.cta}
            <Arrow />
          </GetItButton>
          <span className={`hand ${styles.note}`}>{t.hero.note}</span>
        </div>

        {PRODUCT.productHunt && (
          <a
            className={styles.badge}
            href={PRODUCT.productHunt}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/producthunt.svg" alt={t.hero.productHunt} width={250} height={54} />
          </a>
        )}
      </div>

      <PhoneMenu
        time={t.app.time}
        handLabel={t.app.handLabel}
        title={t.app.title}
        pourable={t.app.pourable}
        byFamily={t.app.byFamily}
        rows={t.app.rows}
        tabs={t.app.tabs}
      />
    </section>
  );
}

export const Arrow = () => (
  <svg
    width="16"
    height="12"
    viewBox="0 0 16 12"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M1 6h13M9.5 1.5 14 6l-4.5 4.5" />
  </svg>
);
